
export default {
  props: {
    product: {
      type: Object,
      default: null
    }
  }
}
